module.exports = __webpack_public_path__ + "img/pet_profile-01.13d727fb.png";